import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=6d9717f0&scoped=true&"
import script from "./FormGroup.vue?vue&type=script&lang=ts&"
export * from "./FormGroup.vue?vue&type=script&lang=ts&"
import style0 from "./FormGroup.vue?vue&type=style&index=0&id=6d9717f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9717f0",
  null
  
)

export default component.exports